import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock } from "vue"

const _hoisted_1 = ["checked", "onChange"]
const _hoisted_2 = { class: "mobile-nav" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_EasyDrop = _resolveComponent("EasyDrop")!

  return (_openBlock(), _createBlock(_component_EasyDrop, {
    customButtonClasses: 'sort-btn',
    customClasses: 'flight-sorting',
    isFullMobile: true,
    hasTopTip: true,
    position: 'center',
    ref: "easyDrop"
  }, {
    buttonText: _withCtx(() => [
      _createTextVNode(_toDisplayString(_ctx.sortButtonText), 1)
    ]),
    contentHeader: _withCtx(() => [
      _createElementVNode("p", null, [
        _createElementVNode("strong", null, _toDisplayString(_ctx.pageTexts['hotelListPageSearchResultSortBy']), 1)
      ])
    ]),
    content: _withCtx(() => [
      _createElementVNode("fieldset", null, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.sortItems, (sort, index) => {
          return (_openBlock(), _createElementBlock("label", {
            class: "standard",
            key: index
          }, [
            _createElementVNode("input", {
              type: "radio",
              name: "resultSortOrder",
              checked: sort.selected,
              onChange: ($event: any) => (_ctx.updateSort(sort))
            }, null, 40, _hoisted_1),
            _createElementVNode("span", null, _toDisplayString(sort.name), 1)
          ]))
        }), 128))
      ])
    ]),
    contentFooter: _withCtx(() => [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("button", {
          type: "button",
          class: "btn-primary",
          onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.closeDropdown && _ctx.closeDropdown(...args)))
        }, _toDisplayString(_ctx.pageTexts['hotelPageGeneralNavigationButtonSave']), 1)
      ])
    ]),
    _: 1
  }, 512))
}